import { EXTERIOR_RISK_TYPE } from '@/constants/accessor/api/emergencyInspectionResult/assessmentDetails/step1/exteriorRiskType'

/** 一見して危険種別 */
export const EXTERIOR_RISK_TYPE_LABELS = [
  { value: EXTERIOR_RISK_TYPE.UNSELECTED, text: '未選択' },
  { value: EXTERIOR_RISK_TYPE.NOT_APPLICABLE, text: '非該当' },
  {
    value: EXTERIOR_RISK_TYPE.TOTAL_OR_PARTIAL_COLLAPSE,
    text: '建築物全体又は一部の崩壊・落階'
  },
  {
    value: EXTERIOR_RISK_TYPE.FOUNDATION_MAJOR_DAMAGE,
    text: '基礎の著しい破壊、上部構造との著しいずれ'
  },
  { value: EXTERIOR_RISK_TYPE.MAJOR_BUILDING_TILT, text: '建築物全体又は一部の著しい傾斜' },
  { value: EXTERIOR_RISK_TYPE.OTHER, text: 'その他' }
] as const

export const step1FieldList: string[] = ['exterior']
